<div class="filter-btn" (click)="toggleFilter()">{{"BUTTON.FILTER" | translate}}</div>
<section class="mt-3 px-4">
    <div class="row gx-3">
        <!-- filter -->
        <div
            [ngClass]="{'filter-close': filterIsClose}"
            class="filter-card col-lg-3 col-md-5 col-12"
        >
            <mat-card class="shadow mb-3">
                <mat-card-header class="justify-content-center">
                    <mat-card-title>{{"PRODUCT.FILTER.TITLE" | translate}}</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <!-- 產品類型 -->
                    <div class="d-flex flex-column mb-3">
                        <label for="">{{"PRODUCT.PRODUCT_TYPE.TITLE" | translate}}</label>
                        <mat-radio-group 
                            [(ngModel)]="productType"
                            (change)="resetFilter()"
                            aria-label="Select an option">
                            <mat-radio-button [value]="TIM_TYPE['TIM']" color="primary">{{"PRODUCT.PRODUCT_TYPE.TYPE_1" | translate}}</mat-radio-button>
                            <mat-radio-button [value]="TIM_TYPE['TMP']" color="primary">{{"PRODUCT.PRODUCT_TYPE.TYPE_2" | translate}}</mat-radio-button>
                        </mat-radio-group>
                    </div>
                    <!-- 篩選項目 -->
                    <ng-container *ngFor="let item of filter">
                        <div *ngIf="item.productType.includes(productType)">
                            <!-- 篩選項目名稱 -->
                            <label class="mb-1">
                                <span>{{"PRODUCT.FILTER.ITEMS." + item.name + ".TITLE" | translate}}</span>
                                <span class="memo-text" *ngIf="item.memo">
                                    ({{"PRODUCT.FILTER.ITEMS." + item.name + ".MEMO" | translate}})
                                </span>
                            </label>
                            <div class="d-flex align-items-center mb-3">
                                <mat-select class="form-control" [(ngModel)]="item.min">
                                    <mat-option [value]="null">-</mat-option>
                                    <ng-container *ngFor="let option of item.options; let idx=index">
                                        <mat-option 
                                            [value]="option" 
                                            *ngIf="!item.max || (item.max && option <= item.max)"
                                        >
                                            {{option}}
                                        </mat-option>
                                    </ng-container>
                                </mat-select>
                                <p class="my-0 mx-2">~</p>
                                <mat-select class="form-control" [(ngModel)]="item.max">
                                    <ng-container *ngFor="let option of item.options; let idx=index">
                                        <mat-option 
                                            [value]="option" 
                                            *ngIf="!item.min || (item.min && option >= item.min)"
                                        >
                                            {{option}}
                                        </mat-option>
                                    </ng-container>
                                </mat-select>
                            </div>
                        </div>
                    </ng-container>
                </mat-card-content>
                <mat-card-actions class="justify-content-center pb-3">
                    <button 
                        mat-raised-button 
                        color="primary"
                        (click)="fetchProductList()">
                        {{"BUTTON.SEARCH" | translate}}
                    </button>
                </mat-card-actions>
            </mat-card>
        </div>
        <!-- 產品list -->
        <div class="col-lg-9 col-md-7 col-12">
            <div>
                <p>
                    <span>{{"PRODUCT.PRODUCT_LIST.HEADER.COUNT_HEAD" | translate}}</span>
                    <span>{{productList.length}}</span>
                    <span>{{"PRODUCT.PRODUCT_LIST.HEADER.COUNT_END" | translate}}</span>
                </p>
            </div>
            <div class="row g-3">
                <ng-container *ngFor="let product of productList">
                    <div class="col-lg-6 col-12" #productCard>
                        <mat-card class="shadow">
                            <mat-card-header
                                class="card-header"
                            >
                                <mat-card-title-group>
                                    <mat-card-title
                                        class="card-title"
                                        [routerLink]="[currentUrl, product.id]"
                                        style="cursor: pointer;"
                                    >
                                        <h2 class="title">
                                            {{product.product_number}}
                                        </h2>
                                    </mat-card-title>
                                    <img
                                        [src]="environment.settings.imageUrl + product.image_path"
                                        [alt]="product.product_number  + '圖片'"
                                        class="product-img"
                                    >
                                </mat-card-title-group>
                            </mat-card-header>
                            <mat-card-content class="my-3">
                                <p class="mb-3">{{product.intro}}</p>
                                <div>
                                    <h5>{{"PRODUCT.PRODUCT_LIST.CARD.SPEC.TITLE" | translate}}</h5>
                                    <ng-container [ngSwitch]="product.type">
                                        <!-- 導熱硅膠 -->
                                        <ng-template [ngSwitchCase]="TIM_TYPE['TIM']">
                                            <p class="mb-1">
                                                <span>{{"PRODUCT.PRODUCT_LIST.CARD.SPEC.WMK" | translate}}：</span>
                                                <span>{{product.features?.thermal_conductivity | number: '1.1-1'}}</span>
                                            </p>
                                            <p class="mb-1">
                                                <span>{{"PRODUCT.PRODUCT_LIST.CARD.SPEC.TEMPERATURE" | translate}}：</span>
                                                <span>{{product.features?.temperature_min | number: '1.1-1'}}</span>
                                                <span>~</span>
                                                <span>{{product.features?.temperature_max | number: '1.1-1'}}</span>
                                            </p>
                                            <p class="mb-1">
                                                <span>{{"PRODUCT.PRODUCT_LIST.CARD.SPEC.THICKNESS" | translate}}：</span>
                                                <span>{{product.features?.thickness_min | number: '1.1-1'}}</span>
                                                <span>~</span>
                                                <span>{{product.features?.thickness_max | number: '1.1-1'}}</span>
                                            </p>
                                            <p class="mb-1">
                                                <span>{{"PRODUCT.PRODUCT_LIST.CARD.SPEC.HARDNESS" | translate}}：</span>
                                                <span>{{product.features?.hardness_str}}</span>
                                                
                                            </p>
                                        </ng-template>
                                        <!-- 導熱硅脂 -->
                                        <ng-template [ngSwitchCase]="TIM_TYPE['TMP']">
                                            <p class="mb-1">
                                                <span>{{"PRODUCT.PRODUCT_LIST.CARD.SPEC.WMK" | translate}}：</span>
                                                <span>{{product.features?.thermal_conductivity | number: '1.1-1'}}</span>
                                            </p>
                                            <p class="mb-1">
                                                <span>{{"PRODUCT.PRODUCT_LIST.CARD.SPEC.TEMPERATURE" | translate}}：</span>
                                                <span>{{product.features?.temperature_min | number: '1.1-1'}}</span>
                                                <span>~</span>
                                                <span>{{product.features?.temperature_max | number: '1.1-1'}}</span>
                                            </p>
                                            <p class="mb-1">
                                                <span>{{"PRODUCT.PRODUCT_LIST.CARD.SPEC.VOLATILE_COMPONENT" | translate}}：</span>
                                                <span>{{product.features?.volatile_component| number: '1.1-2'}}%</span>
                                                <span>{{"("}}</span>
                                                <span>{{product.features?.volatile_temperature | number: '1.1-2'}}℃, </span>
                                                <span>{{product.features?.volatile_hour | number: '1.1-2'}}hr </span>
                                                <span>{{")"}}</span>
                                            </p>
                                        </ng-template>
                                    </ng-container>
                                </div>
                                <div></div>
                            </mat-card-content>
                            <mat-card-actions class="justify-content-end pb-3">
                                <button
                                    mat-raised-button
                                    color="primary"
                                    [routerLink]="['/custom/product/autodraw']" 
                                    [queryParams]="{
                                        type: product.type,
                                        pn: product.product_number,
                                    }"
                                >
                                    <span *ngIf="product.type !== TIM_TYPE['TMP']; else tmpType">{{"BUTTON.AUTO_DRAW" | translate}}</span>
                                    <ng-template #tmpType>{{"BUTTON.CONTACT_QUOTE" | translate}}</ng-template>
                                </button>
                            </mat-card-actions>
                        </mat-card>
                    </div>
                </ng-container>
                <!-- 客製化 -->
                <div
                    *ngIf="customCardHeight"
                    class="col-lg-6 col-12 custom-card"
                    [style.height.px]="customCardHeight"
                    style="user-select: none;"
                    (click)="nevigateToAudoDraw()"
                >
                    <mat-card class="h-100 shadow">
                        <mat-card-header class="h-100">
                          <mat-card-title-group class="justify-content-center align-items-center">
                            <mat-card-title class="w-100">
                                <h2 class="card-title">{{"PRODUCT.PRODUCT_LIST.CUSTOM.TITLE" | translate}}</h2>
                            </mat-card-title>
                          </mat-card-title-group>
                        </mat-card-header>
                        <mat-card-actions></mat-card-actions>
                    </mat-card>
                </div>
            </div>
        </div>
    </div>
</section>